const resetPasswordConstants = {
    PASSWORD_SUCCESSFULLY_RESET: 10,
    PASSWORD_NOT_RESET: 20,
    USER_NOT_VALIDATED: 30
}

export default resetPasswordConstants;



// WEBPACK FOOTER //
// ./src/constants/resetPassword.js